/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { switchMap, map, catchError, takeUntil, exhaustMap, tap, mapTo } from 'rxjs/operators';
import { cashboxesClient } from '../../../api/cashBoxes/cashboxesClient';
import { from, of } from 'rxjs';
import {
    CashBoxAiClassificationTabAction,
    CashBoxAiClassificationTabActionType,
    fetchCashboxClassificationsHistorySuccessAction,
    fetchCashboxClassificationsHistoryErrorAction,
    downloadCashboxClassificationsHistoryErrorAction,
    downloadCashboxClassificationsHistorySuccessAction,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxAiClassificationTabActions';
import { downloadDataAsFile, parseError } from '../../../../utils/utils';
import { i18n } from '../../../translation/i18n';
import { AxiosError } from 'axios';

export const fetchCashboxClassificationsHistoryEpic: Epic<CashBoxAiClassificationTabAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashBoxAiClassificationTabActionType.FETCH_AI_CLASSIFICATIONS_HISTORY),
        switchMap((action) => {
            const params = action.payload;
            const taxNumber = state$.value.routerState.route.params.CashboxTaxNumber;
            const listName = i18n.t('RegistryScreens.aiClassificationsHistory').toLocaleLowerCase();

            return from(cashboxesClient.getAiClassificationsHistory(taxNumber, params)).pipe(
                map((resp) => {
                    return fetchCashboxClassificationsHistorySuccessAction(resp);
                }),
                catchError((err: AxiosError) =>
                    of(
                        fetchCashboxClassificationsHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedLoadList', { listName })),
                        ),
                    ),
                ),
                takeUntil(action$.ofType(CashBoxAiClassificationTabActionType.EXIT_CASHBOX_AI_CLASSIFICATIONS_TAB)),
            );
        }),
    );
};

export const cashboxClassificationsHistoryDownloadEpic: Epic<CashBoxAiClassificationTabAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashBoxAiClassificationTabActionType.DOWNLOAD_AI_CLASSIFICATIONS_HISTORY),
        exhaustMap(() => {
            const taxNumber = state$.value.routerState.route.params.CashboxTaxNumber;
            const fileName = `cashbox_${taxNumber}_AiClassificationsHistory.xls`;

            return from(cashboxesClient.downloadAiClassificationsHistoryAsExcel(taxNumber)).pipe(
                tap((fileData) => downloadDataAsFile(fileName, fileData)),
                mapTo(downloadCashboxClassificationsHistorySuccessAction()),

                catchError((err: AxiosError) =>
                    of(
                        downloadCashboxClassificationsHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedUploadFileName', { fileName })),
                        ),
                    ),
                ),
            );
        }),
    );
};
